module.exports = __webpack_public_path__ + "static/img/6.a86ecbb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/zh/6.png
// module id = 0doH
// module chunks = 0